module.exports = __webpack_public_path__ + "img/cyclogramme-symptothermie-moonly-app-medium.9befaa36.png";